import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router} from '@angular/router';


declare let changeContextChatbotAppliMobile: (rubrique: string, dialog: string) => void;
declare let reinitContextChatbotAppliMobile: () => void;

@Component({
  selector: 'cnaf-contacter-forte-affluence-svi',
  templateUrl: './contactermacaf-forteaffluence-svi.component.html',
  styleUrls: ['./contactermacaf-forteaffluence-svi.component.css']
})

export class ForteAffluenceComponent implements OnInit, OnDestroy {
  constructor(private router: Router) { }

  ngOnDestroy(): void {
    if (typeof reinitContextChatbotAppliMobile === 'function') {
      reinitContextChatbotAppliMobile();
    }
  }

  clickOnRetour(): void {
    this.router.navigateByUrl("./contactcaf");
  }

  ngOnInit(): void {   
    if (typeof changeContextChatbotAppliMobile === 'function') {
      changeContextChatbotAppliMobile('SVI_VISUEL', 'testsvicontext');
    }
  }
}
